export default "__VITE_ASSET__BormjUSm__"